import BubbleSmileIcon from "@/assets/dark_gradient/bubble_smile.svg?react";
import Modal from "@/components/Common/Modal";
import {isDeleteTemplateModalOpenAtom} from "@/store/jotaiAtoms";
import {useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const DeleteTemplateModal: FC<{onDelete: () => void}> = ({onDelete}) => {
  const setShowDeleteTemplateModal = useSetAtom(isDeleteTemplateModalOpenAtom);
  const {t} = useTranslation("common");

  return (
    <Modal
      onClose={() => {
        setShowDeleteTemplateModal(false);
      }}
      onConfirm={onDelete}
      shouldCloseOnConfirm
      shouldHideModalTitle
      customTitleRow={
        <div className="flex items-center gap-2 p-5">
          <BubbleSmileIcon className="size-5 shrink-0" />
          <span className="text-neutral-black text-xl font-semibold">{t("delete_template")}</span>
        </div>
      }>
      <div className="flex items-center justify-center text-xl font-semibold">{t("delete_template_confirmation")}</div>
    </Modal>
  );
};

export default DeleteTemplateModal;
